module.exports = __webpack_public_path__ + "static/media/icon_shield.4119ea6a.svg";